import { Component } from "react";

class ScrollTopOnUpdate extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.location !== nextProps.location;
  }
  componentDidUpdate(prevProps) {
    if (this.props.location.hash) {
      let element;
      try {
        element = document.querySelector(this.props.location.hash);
      } catch (e) {
        element = null;
      }
      if (element) {
        element.scrollIntoView();
        element.focus();
        return;
      }

      if (
        this.props.location.pathname === prevProps.location.pathname &&
        this.props.location.search === prevProps.location.search
      ) {
        return;
      }
    }

    // see https://stackoverflow.com/a/779785/7271467
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }
  render() {
    return null;
  }
}

export default ScrollTopOnUpdate;
